module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-2000.bf4c9ce4.svg";